// extracted by mini-css-extract-plugin
module.exports = {"rightContentImage":"classes_rightContentImage__1U_Fn","cartTitle":"classes_cartTitle__1Jp02"};